import axios from "axios";
import { APP_CONSTANTS } from "../constants/AppConstants";
import { readToken } from "../services/localStorage.service";
import { ApiError } from "./ApiError";
import { toast } from "react-toastify";

export const baseURL = APP_CONSTANTS.base_url;
export const httpApi = axios.create({
  baseURL: baseURL,
});

httpApi.interceptors.request.use((config: any) => {
  if (
    config.url === "auth/token/" ||
    config.url === "users/google/" ||
    (config && config.url && config.url.includes("authorize_callback/"))
  ) {
    config.headers = {
      ...config.headers,
    };
  } else {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${readToken()}`,
    };
  }

  return config;
});

httpApi.interceptors.response.use(undefined, (error: any) => {
  if (error?.response?.status === 401) {
    const isInPopup = window.location.href.includes('#popup') || 
                      document.querySelector('.popup-container') !== null;
    
    if (!isInPopup && window.location.pathname !== "/auth/login") {
      sessionStorage.setItem('authError', 'true');
      window.location.href = "/auth/login";
    }
    
    return Promise.reject({
      isAuthError: true,
      originalError: error
    });
  }
  
  if (error?.response?.status === 404) {
    const errorMessage = error?.response?.data?.message || "Resource not found";
    toast.error(errorMessage);
  }
  
  throw new ApiError<ApiErrorData>(
    error && error.response?.data["message"]
      ? error.response?.data["message"]
      : error.message
  );
});

export interface ApiErrorData {
  message: string;
}
